import * as React from "react";
var Overlay = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: "wds-modal__overlay", onClick: onClick }));
};
export default Overlay;
//# sourceMappingURL=Overlay.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/internal/Overlay/Overlay.js
// module id = 1795
// module chunks = 17